import { CUSTOM_FORMAT } from "./constants.js";
import toDate from "./toDate.js";
import toString_0 from "./toString.js";
const format = (dateToFormat, fmt, inputFmt, lang = 'es')=>{
    const date = 'string' == typeof dateToFormat ? toDate(dateToFormat, inputFmt) : dateToFormat;
    if (date && 'boolean' != typeof date) return toString_0(date, fmt || CUSTOM_FORMAT, lang);
    return '';
};
const date_format = format;
export default date_format;
